import { render, staticRenderFns } from "./ReplymessageForm.vue?vue&type=template&id=6ef273ae&"
import script from "./ReplymessageForm.vue?vue&type=script&lang=js&"
export * from "./ReplymessageForm.vue?vue&type=script&lang=js&"
import style0 from "./ReplymessageForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports